@if (schema?.title) {
    <span class="text-primary-darker-h4 wizard-title">{{ schema.title }}</span>
}

<form [formGroup]="group" class="flex-column wizard-fields">
    @for (field of fields; track field.key) {
        @switch (field.kind) {
            @case ('select') {
                <mat-form-field appearance="outline">
                    <mat-label>{{ field.label }}</mat-label>
                    <mat-select [formControlName]="field.key">
                        @for (option of field.options; track option.value) {
                            <mat-option [value]="option.value">{{ option.label }}</mat-option>
                        }
                    </mat-select>
                    <mat-error>{{ errorText(field) }}</mat-error>
                </mat-form-field>
            }
            @case ('multiselect') {
                <mat-form-field appearance="outline">
                    <mat-label>{{ field.label }}</mat-label>
                    <mat-select [formControlName]="field.key" multiple>
                        @for (option of field.options; track option.value) {
                            <mat-option [value]="option.value">{{ option.label }}</mat-option>
                        }
                    </mat-select>
                    <mat-error>{{ errorText(field) }}</mat-error>
                </mat-form-field>
            }
            @case ('radio') {
                <div class="flex-column field-block">
                    <span class="subtitle-2">{{ field.label }}{{ field.required ? '*' : '' }}</span>
                    <mat-radio-group [formControlName]="field.key" class="flex-row wrap gap-5percent">
                        @for (option of field.options; track option.value) {
                            <mat-radio-button [value]="option.value">{{ option.label }}</mat-radio-button>
                        }
                    </mat-radio-group>
                    @if (hasError(field)) { <mat-error>{{ errorText(field) }}</mat-error> }
                </div>
            }
            @case ('boolean') {
                <mat-checkbox [formControlName]="field.key" class="field-block">{{ field.label }}</mat-checkbox>
            }
            @case ('textarea') {
                <mat-form-field appearance="outline">
                    <mat-label>{{ field.label }}</mat-label>
                    <textarea matInput rows="4" [formControlName]="field.key" [placeholder]="field.placeholder ?? ''"></textarea>
                    <mat-error>{{ errorText(field) }}</mat-error>
                </mat-form-field>
            }
            @case ('number') {
                <mat-form-field appearance="outline">
                    <mat-label>{{ field.label }}</mat-label>
                    <input matInput type="number" [formControlName]="field.key" [placeholder]="field.placeholder ?? ''">
                    <mat-error>{{ errorText(field) }}</mat-error>
                </mat-form-field>
            }
            @case ('date') {
                <app-date-picker
                    [name]="field.key"
                    [form]="group"
                    [label]="field.label ?? ''"
                    [placeholder]="field.placeholder ?? ''"
                    [startDate]="todayStartDate">
                </app-date-picker>
            }
            @case ('datetime') {
                <div class="flex-column field-block">
                    <span class="subtitle-2">{{ field.label }}{{ field.required ? '*' : '' }}</span>
                    <div class="flex-row gap-actions align-center-center datetime-row">
                        <app-date-picker
                            class="flex-60"
                            [name]="datetimeDateKey(field.key)"
                            [form]="group"
                            [label]="field.label"
                            [placeholder]="field.placeholder ?? ''"
                            [startDate]="todayStartDate">
                        </app-date-picker>
                        <mat-form-field appearance="outline" class="flex-40">
                            <mat-label>Hora</mat-label>
                            <input matInput type="time" [formControlName]="datetimeTimeKey(field.key)">
                        </mat-form-field>
                    </div>
                    @if (hasError(field)) { <mat-error>{{ errorText(field) }}</mat-error> }
                </div>
            }
            @default {
                <mat-form-field appearance="outline">
                    <mat-label>{{ field.label }}</mat-label>
                    <input matInput type="text" [formControlName]="field.key" [placeholder]="field.placeholder ?? ''">
                    <mat-error>{{ errorText(field) }}</mat-error>
                </mat-form-field>
            }
        }
    }
</form>

<div class="wizard-footer">
    <button *ngIf="showCancel" mat-stroked-button color="primary" type="button" (click)="cancelled.emit()">CANCELAR</button>
    <div class="flex-row gap-actions">
        @if (canGoBack) {
            <button mat-stroked-button color="primary" type="button" (click)="back()">ANTERIOR</button>
        }
        @if (canGoNext) {
            <button mat-flat-button color="primary" type="button" (click)="next()">SIGUIENTE</button>
        }
        @if (isLast) {
            <button mat-flat-button color="primary" type="button" (click)="submit()">CONFIRMAR</button>
        }
    </div>
</div>
